import {
  CopyOutlined,
  DownloadOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  message,
  Popconfirm,
  Row,
  Space,
  Spin,
  Table,
  Tabs,
  Typography,
  Upload,
} from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import InputFields from "../../components/InputFields/InputFields";
import {
  dataFindContract,
  dataFormReason,
  fieldsPatient,
  listColumnsTableCreated,
} from "../ContractList/config";
import ModalCustom from "../../components/ModalCustom/ModalCustom";
import contract from "../../api/contract";
import Notification from "../../components/Notification";
import Search from "../../components/Search/Search";
import ListActionButton from "../../components/ListActionButton/ActionListButton";
import { ROLES } from "../../type/roles";
import { FIELD_TYPE } from "../../type/fileType";
import {
  base64ListToFileList,
  fileToBase64,
  formatDateToString,
} from "../../helper/common";
import user from "../../api/user";
import { CKEditor } from "@ckeditor/ckeditor5-react";
// import Editor from "ckeditor5-custom/build/ckeditor";
import Editor from "ckeditor5-custom-build/ckeditor5/build/ckeditor";
import ImageUploader from "./ImageUploader";

const ContractList = () => {
  const [formCreteContract] = Form.useForm();
  const [formChoseeContract] = Form.useForm();
  const [fileUrl, setFileUrl] = useState(null);

  const [dataTableCreated, setDataTableCreated] = useState([]);

  const editContract = useRef();
  const openUploadModalRef = useRef();
  const [dataSource, setDataSource] = useState(fieldsPatient);
  const [total, setTotal] = useState();
  const previewContract = useRef();
  const [loadingPage, setLoadingPage] = useState(false);
  const [params, setParams] = useState({
    pageNumber: 1,
    pageSize: 20,
  });
  const [dataSearch, setDataSearch] = useState(dataFindContract);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [dataSelectedRow, setDdataSelectedRow] = useState(null);
  const [isDownload, setIsDownload] = useState(false);

  const [dataInfoStudent, setDataInfoStudent] = useState([]);
  const [createKeyContract, setCreateKeyContract] = useState(1);
  const [linkSignByCus, setLinkSignByCus] = useState(null);
  const findRef = useRef();
  const signSecureRef = useRef();

  const [reasonReject, setReasonReject] = useState(false);
  const [formReason] = Form.useForm();
  const [templateId, setTemplateId] = useState(null);
  const [textContract, setTextContract] = useState({
    text: "Thêm mới",
    status: 0,
  });
  const [optionsLeaders, setOptionsLeaders] = useState([]);
  const [tempFile, setTempFile] = useState(null);
  const [tempTextContract, setTempTextContract] = useState(null);

  const [optionContarct, setOptionContract] = useState([]);
  // xử lý edditor
  const [content, setContent] = useState();
  const [fileList, setFileList] = useState([]);

  // const [editorState, setEditorState] = useState(() =>
  //   EditorState.createEmpty()
  // );
  // const onEditorStateChange = useCallback((editorState) => {
  //   setEditorState(editorState);
  // }, []);
  const getListContractUpload = async () => {
    try {
      const res = await contract.getListContractUpload();
      const options = Array.isArray(res.data)
        ? res.data.map((item) => ({
            label: item.name,
            value: item.id,
          }))
        : [];
      setOptionContract(options);
      const newDataSource = dataSource.map((field) =>
        field.name === "id" ? { ...field, options: options } : field
      );
      setDataSource(newDataSource);
      Notification("success", "Lấy danh sách hợp đồng thành thành công");
    } catch (error) {
      Notification("error", "Lấy danh sách hợp đồng không thành công");
    }
  };

  // useEffect(() => {
  //   setDataSource([...dataSource]);
  // }, [dataSource]);

  const handleSaveContract = async () => {
    try {
      const data = await formCreteContract.validateFields();
      console.log(data);
      const templateId = formChoseeContract.getFieldValue("id");

      let cccdImageBase64Arr = [];

      if (fileList.length > 0) {
        cccdImageBase64Arr = await Promise.all(
          fileList.map((item) => fileToBase64(item.originFileObj))
        );
      }
      const dataOutput = {
        fieldValues: {
          ...data,
          // contractAppendix: toHtmlOrEmpty(editorState),
          contractAppendix: content,
          cccdImages: JSON.stringify(cccdImageBase64Arr),
        },
        templateId: templateId,
        contractName:
          optionContarct.find((item) => item.value === templateId)?.label || "",
      };
      // Lưu hợp đồng
      await contract.saveContractCreated(dataOutput);
      Notification("success", "Lưu hợp đồng thành công");
      editContract.current.closeModal();
      setContent(null);
      openUploadModalRef.current.closeModal();
      getListContractCreated();
      setFileList([]);
      // formCreteContract.resetFields();
      formChoseeContract.resetFields();
    } catch (error) {
      console.log(error);

      Notification("error", `Đã xảy ra lỗi khi lưu ${error}`);
    }
  };

  const getListContractCreated = async () => {
    try {
      const res = await contract.getListContractCreated({
        ...params,
        startDate: formatDateToString(params.startDate),
        endDate: formatDateToString(params.endDate),
      });
      const newDataSource = res.data.data.map((item) => ({
        ...item,
        key: item.id,
      }));
      setDataTableCreated(newDataSource);
      setTotal(res.data.total);
      Notification("success", "Lấy danh sách mẫu hợp đồng thành công");
    } catch (error) {
      Notification("error", "Lấy danh sách mẫu hợp đồng không thành công");
    }
  };

  // hàm tạo dữ liệu fields từ res
  const genFields = (res) => {
    const result = res.data.fieldNames
      .filter(
        (item) =>
          item !== "sysMoneyInWords" &&
          item !== "sysCustSignature" &&
          item !== "moneyInWords" &&
          item !== "custSignature" &&
          item !== "cccdImages"
      )
      .map((key) =>
        key === "money"
          ? {
              type: FIELD_TYPE.CURRENCY, // quy tắc đặt type
              label: res.data.fieldMetadata[key] || key,
              name: key,
              rules: [
                {
                  required: true,
                  message: "Chưa nhập " + res.data.fieldMetadata[key],
                },
              ],
            }
          : {
              type: FIELD_TYPE.INPUT, // quy tắc đặt type
              label: res.data.fieldMetadata[key] || key,
              name: key,
              rules: [
                {
                  required: true,
                  message: "Chưa nhập " + res.data.fieldMetadata[key],
                },
              ],
            }
      );

    setDataInfoStudent([...result]);
    editContract.current.openModal();
  };

  const handleCreateContract = async () => {
    setLoadingPage(true);
    setFileList([]);
    try {
      const data = await formChoseeContract.validateFields();

      if (createKeyContract === 1) {
        const res = await contract.getFieldsContractUpload(data.id);
        genFields(res);
      } else {
        const formData = new FormData();
        formData.append("file", tempFile.file);
        await contract.createMultiContract(formData, data.id);
      }
      openUploadModalRef?.current?.closeModal();
      setContent(null);
      setTempFile(null);
      getListContractCreated();
      setLoadingPage(false);
    } catch (error) {
      console.log("🚀 ~ handleCreateContract ~ error:", error);
      setLoadingPage(false);
      Notification("error", "Không lấy được dữ liệu");
    }
  };

  const onChangePagination = (pageNumber, pageSize) => {
    setParams({ ...params, pageNumber: pageNumber, pageSize: pageSize });
  };

  const deleteContracted = async (id) => {
    setLoadingPage(true);
    try {
      await contract.deleteContractCreated(id);
      Notification("success", "Xóa hợp đồng thành công");
      getListContractCreated();
      setLoadingPage(false);
    } catch (error) {
      setLoadingPage(false);

      Notification("error", "Xóa hợp đồng thất bại");
    }
  };

  const editContracted = async (id, show) => {
    setTemplateId(id);
    setTextContract({
      text: "Chỉnh sửa",
      status: 1,
    });
    setFileList([]);
    try {
      const res = await contract.detailContractCreated(id);
      const value = res?.data?.fieldValues;

      if (!value?.contractAppendix) {
        setContent("");
      }
      setContent(value?.contractAppendix);
      const isCccdImagesArray = value?.cccdImages
        ? JSON.parse(value?.cccdImages)
        : null;
      if (isCccdImagesArray && Array.isArray(isCccdImagesArray)) {
        const data = base64ListToFileList(isCccdImagesArray);
        setFileList(data);
      }
      formCreteContract.setFieldsValue(res.data.fieldValues);
      if (show) {
        genFields(res);
      }
      return res;
    } catch (error) {
      console.log(error);
      Notification("error", `Đã xảy ra lỗi: ${error?.message}`);
    }
  };

  // Chỉnh sửa hợp đông
  const handleEditContract = async () => {
    try {
      const res = await formCreteContract.validateFields();
      let cccdImageBase64Arr = [];
      console.log(fileList);

      if (fileList.length > 0) {
        cccdImageBase64Arr = await Promise.all(
          fileList.map((item) => fileToBase64(item.originFileObj))
        );
      }
      await contract.updateContractCreated({
        fieldValues: {
          ...res,
          // contractAppendix: toHtmlOrEmpty(editorState),
          contractAppendix: content,
          cccdImages: JSON.stringify(cccdImageBase64Arr),
        },
        contractId: templateId,
      });
      editContract.current.closeModal();
      formCreteContract.resetFields();
      getListContractCreated();
      setFileList([]);
      Notification("success", "Cập nhật thông tin thành công");
    } catch (error) {
      console.log("🚀 ~ handleEditContract ~ error:", error);
      Notification("error", "Cập nhật thông tin thất bại");
    }
  };

  const showContract = async (id) => {
    setLoadingPage(true);
    try {
      setTemplateId(id);
      const res = await contract.getViewContractedCreate({
        contractId: id,
        format: "pdf",
      });
      const { base64Content, contentType } = res.data;
      const fileUrl = `data:${contentType};base64,${base64Content}`;
      setFileUrl(fileUrl);
      previewContract.current.openModal();
      setLoadingPage(false);
    } catch (error) {
      setLoadingPage(false);
      Notification("error", "Đã xảy ra lỗi khi xem chi tiết");
    }
  };

  // Duyệt hợp đồng
  const handleApproveContract = async () => {
    try {
      const data = {
        contractId: templateId, // Thay thế bằng ID hợp đồng thực tế
      };
      if (!templateId) {
        Notification("error", "Không tìm thấy hợp đồng để duyệt");
        return;
      }
      await contract.approveContractCreated(data);
      getListContractCreated();
      previewContract.current.closeModal();
    } catch (error) {
      console.log("🚀 ~ handleApproveContract ~ error:", error);
      Notification("error", "Duyệt hợp đồng thất bại " + error?.message);
    }
  };
  // Từ chối duyệt
  const hanleRejectContract = async () => {
    try {
      const res = await formReason.validateFields();
      const data = {
        ...res,
        contractId: templateId,
      };
      await contract.rejectContractCreated(data);
      getListContractCreated();
      previewContract.current.closeModal();
      formReason.resetFields();
      setReasonReject(false);
    } catch (error) {
      Notification("error", "Từ chối duyệt hợp đồng thất bại");
    }
  };

  const handleSearch = () => {
    const data = findRef.current?.getData();
    setParams({
      ...params,
      ...data,
      pageNumber: 1,
    });
  };

  const getListLeader = async () => {
    try {
      const res = await user.getListLeader();
      const options = res.data.map((opt) => ({
        label: opt.fullName,
        value: opt.id,
      }));
      setOptionsLeaders(options);
    } catch (error) {
      Notification("error", "Lấy danh sách leader không thành công");
    }
  };

  // lấy ảnh chữ ký
  const handleOnView = async (id) => {
    setLoadingPage(true);
    try {
      const res = await editContracted(id, false);
      setLinkSignByCus(res?.data?.linkSignContract);
      signSecureRef.current.openModal();
      setLoadingPage(false);
    } catch (error) {
      setLoadingPage(false);
      Notification("error", "Đã xảy ra lỗi khi xem chi tiết");
    }
  };

  const customRequest = (options) => {
    setLoadingPage(true);

    try {
      // Tạo một FormData để gửi tệp lên máy chủ
      setTempFile(options);
      setTempTextContract(options.file.name);
      Notification("success", "Đã tải file thành công");
      setLoadingPage(false);
    } catch (error) {
      setLoadingPage(false);
      Notification(
        "error",
        "Lỗi khi tải file hoặc kích cỡ file đạt quá giới hạn"
      );
    }
    return false;
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(linkSignByCus);
      message.success("Đã copy link!");
    } catch (e) {
      message.error("Copy thất bại");
    }
  };
  const handleDownload = async () => {
    setLoadingPage(true);

    try {
      const res = await contract.downloadContractCreated({
        files: dataSelectedRow,
      });

      const contentType = res.headers["content-type"];

      const isPdf = contentType?.includes("pdf");

      if (isPdf) {
        const blob = new Blob([res.data], { type: "application/pdf" });
        const disposition = res.config;

        const genJSON = JSON.parse(disposition);

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = genJSON?.files[0]?.fileName || "file.pdf"; // tên file bạn muốn
        a.click();
      } else {
        // Lấy filename từ header

        let fileName = "download.zip";

        // if (disposition) {
        //   const match = disposition.match(/filename="(.+)"/);
        //   if (match && match[1]) fileName = match[1];
        // }

        // Lấy đúng mime type từ backend (nếu có)
        const mimeType =
          res.headers["content-type"] || "application/octet-stream";

        // Tạo blob
        const blob = new Blob([res.data], { type: mimeType });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        a.href = url;
        a.download = fileName; // đúng tên BE trả về
        document.body.appendChild(a);

        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
      setLoadingPage(false);
    } catch (error) {
      console.log(error);
      Notification(
        "error",
        error?.status === 400
          ? "Không có link tải xuống"
          : "Tải file không thành công"
      );
    } finally {
      setLoadingPage(false);
    }
  };

  const onChange = (key) => {
    setCreateKeyContract(key);
  };
  const items = [
    {
      key: 1,
      label: "Tạo hợp đồng lẻ",
    },
    {
      key: 2,
      label: "Tạo nhiều hợp đồng",
    },
  ];

  const onSelectChange = (newSelectedRowKeys, row) => {
    setSelectedRowKeys(newSelectedRowKeys);
    const newDataSelectedRow = row.map((item) => {
      const file = item?.filePath?.split("/");

      return {
        fileName: file?.slice(-1).join("/"),
        subPath: file?.slice(-5, -1).join("/"),
      };
    });

    setDdataSelectedRow(newDataSelectedRow);
    setIsDownload(newSelectedRowKeys.length > 0 ?? false);
  };
  // rowSelection object indicates the need for row selection
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  //columns bảng
  const columns = listColumnsTableCreated.map((e) => {
    if (e.key === "stt") {
      return {
        ...e,
        render: (text, record, index) =>
          (params.pageNumber - 1) * params.pageSize + index + 1,
      };
    } else if (e.key == "action") {
      const role = localStorage.getItem("roles");
      return {
        ...e,
        render: (_, record, index) =>
          role?.includes(ROLES.ROLE_ADMIN) ? (
            <ListActionButton
              deleteFunction={() => deleteContracted(record.id)}
              showDetailFunction={() => showContract(record.id)}
              editFunction={() => editContracted(record.id, true)}
              // sendEmail={() => sendEmail(record.id)}
              signCustomer={() => handleOnView(record.id)}
              record={record}
            />
          ) : (
            <ListActionButton
              showDetailFunction={() => showContract(record.id)}
              editFunction={() => editContracted(record.id, true)}
              // sendEmail={() => sendEmail(record.id)}
              signCustomer={() => handleOnView(record.id)}
              record={record}
            />
          ),
      };
    }
    return e;
  });

  useEffect(() => {
    const newFieldsSearch = dataSearch.map((item) =>
      item.name === "leadTeam"
        ? {
            ...item,
            options: optionsLeaders,
          }
        : { ...item }
    );
    setDataSearch(newFieldsSearch);
  }, [optionsLeaders]);
  // Gọi danh sách
  useEffect(() => {
    getListContractUpload();
    getListLeader();
  }, []);

  useEffect(() => {
    getListContractCreated();
  }, [params]);

  return (
    <Spin spinning={loadingPage}>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        {/* Danh sách hợp đông */}
        <div
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              handleSearch();
            }
          }}
        >
          <Row className="container">
            <Search
              fields={dataSearch}
              onClickSearch={handleSearch}
              ref={findRef}
            />
          </Row>
        </div>
        {/* Hết */}
        {/* ------------------- */}

        <div className="container">
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <Row justify="space-between">
              <div className="title">Danh sách hợp đồng đã tạo</div>
              <Row justify={"space-around"} gutter={[16, 16]}>
                <Col>
                  {isDownload === true && (
                    <Button
                      icon={<DownloadOutlined />}
                      onClick={handleDownload}
                    >
                      Tải xuống
                    </Button>
                  )}
                </Col>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    formCreteContract.resetFields();
                    formChoseeContract.resetFields();
                    openUploadModalRef.current.openModal();
                    setTextContract({
                      text: "Thêm mới",
                      status: 0,
                    });
                  }}
                >
                  Thêm mới hợp đồng
                </Button>
              </Row>
            </Row>
            {/* Danh sách hợp đồng đã tạo */}
            <Table
              columns={columns}
              dataSource={dataTableCreated}
              pagination={{
                position: ["bottomRight"],
                showSizeChanger: true,
                total: total,
                pageSize: params.pageSize,
                current: params.pageNumber,
                onChange: onChangePagination,
              }}
              rowSelection={rowSelection}
              bordered
            />
          </Space>
        </div>
        {/* Chọn hợp đồng để sửa */}
        <ModalCustom
          ref={openUploadModalRef}
          title={`${textContract.text} hợp đồng`.toLocaleUpperCase()}
        >
          <Space direction="vertical" size="large" style={{ width: "100%" }}>
            <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
            <Form form={formChoseeContract} labelAlign="left">
              <Row gutter={[16, 16]}>
                <InputFields data={dataSource} />
                <Col
                  style={{
                    display: createKeyContract === 2 ? "block" : "none",
                  }}
                  span={24}
                >
                  {tempTextContract ? (
                    <Row justify={"space-between"}>
                      <div style={{ fontWeight: "bold" }}>
                        Hợp đồng : {tempTextContract}
                      </div>
                      <Upload
                        customRequest={customRequest}
                        accept=".xlsx"
                        multiple
                        showUploadList={false}
                      >
                        <Button
                          type="default"
                          className="btn-sub"
                          icon={<UploadOutlined rev={undefined} />}
                        >
                          Tải lại danh sách
                        </Button>
                      </Upload>
                    </Row>
                  ) : (
                    <Upload
                      customRequest={customRequest}
                      accept=".xlsx"
                      multiple
                      showUploadList={false}
                    >
                      <Button
                        type="primary"
                        className="btn-sub"
                        icon={<UploadOutlined rev={undefined} />}
                      >
                        Tải danh sách
                      </Button>
                    </Upload>
                  )}
                </Col>
              </Row>
            </Form>

            <Row justify={"end"}>
              <Space direction="horizontal" size="small">
                <Button type="primary" onClick={handleCreateContract}>
                  Thêm mới
                </Button>
                <Button
                  danger
                  onClick={() => openUploadModalRef.current.closeModal()}
                >
                  Hủy
                </Button>
              </Space>
            </Row>
          </Space>
        </ModalCustom>
        {/* Hết */}
        {/* ------------------- */}
        {/* Chỉnh sửa hợp đồng */}
        <ModalCustom
          ref={editContract}
          title={`${textContract.text} hợp đồng`.toLocaleUpperCase()}
        >
          <Space direction="vertical" size="large" style={{ width: "100%" }}>
            <Form form={formCreteContract} labelAlign="left">
              <Row gutter={[16, 16]}>
                <InputFields data={dataInfoStudent} />
                <Col span={24}>
                  <Form.Item
                    label="Ảnh CCCD"
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                    // getValueFromEvent={() => editorState}
                    getValueFromEvent={() => content}
                  >
                    <ImageUploader
                      fileList={fileList}
                      setFileList={setFileList}
                    />
                  </Form.Item>
                </Col>
                <Col xl={24} className="editor">
                  <Form.Item
                    label="Điều khoản hợp đồng"
                    name={"contractAppendix"}
                    labelCol={{ xl: 4 }}
                    wrapperCol={{ xl: 20 }}
                    // getValueFromEvent={() => editorState}
                    getValueFromEvent={() => content}
                  >
                    <CKEditor
                      editor={Editor}
                      // config={}editorConfiguration
                      data={content ?? ""}
                      onReady={(event) => {
                        // You can store the "editor" and use when it is needed.
                      }}
                      onChange={async (event, editor) => {
                        const _data = editor?.getData();
                        setContent(_data);
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <Row justify={"end"}>
              <Space direction="horizontal" size="small">
                <Button
                  type="primary"
                  onClick={
                    textContract.status === 0
                      ? handleSaveContract
                      : handleEditContract
                  }
                >
                  {textContract.text}
                </Button>
                <Button
                  danger
                  onClick={() => editContract.current.closeModal()}
                >
                  Hủy
                </Button>
              </Space>
            </Row>
          </Space>
        </ModalCustom>
        {/* Hết */}
        {/* ------------------- */}
        {/* Xem hợp đồng */}
        <ModalCustom
          ref={previewContract}
          title="Xem trước hợp đồng"
          width={1600}
        >
          <Spin spinning={fileUrl ? false : true}>
            <Space
              direction="vertical"
              size={"middle"}
              style={{ width: "100%" }}
            >
              <div>
                {fileUrl && (
                  <iframe
                    src={fileUrl}
                    width="100%"
                    height="700px"
                    style={{ border: "none" }}
                  />
                )}
                {/* <PdfEditor fileData={fileUrl} /> */}
              </div>
              {localStorage.getItem("roles")?.includes(ROLES.ROLE_ADMIN) && (
                <Row justify="end">
                  <Space direction="horizontal" size="middle">
                    {reasonReject ? (
                      <Space style={{ width: "100%" }}>
                        <Form form={formReason}>
                          <Row gutter={[16, 8]}>
                            <InputFields data={dataFormReason} />
                          </Row>
                        </Form>
                        <Button type="primary" onClick={hanleRejectContract}>
                          Gửi
                        </Button>
                        <Button danger onClick={() => setReasonReject(false)}>
                          Hủy
                        </Button>
                      </Space>
                    ) : (
                      <>
                        <Button danger onClick={() => setReasonReject(true)}>
                          Sửa lại
                        </Button>
                        <Popconfirm
                          className="danger-confirm"
                          title="Bạn có chắc chắn?"
                          onConfirm={handleApproveContract}
                          type="danger"
                        >
                          <Button type="primary">Duyệt</Button>
                        </Popconfirm>
                      </>
                    )}
                  </Space>
                </Row>
              )}
            </Space>
          </Spin>
        </ModalCustom>
        {/* Hết */}
        {/* ------------------- */}
        {/*  Ký bảo mật khach hàng*/}
        <ModalCustom
          ref={signSecureRef}
          width={1200}
          title={"Link hợp đồng cá nhân học viên"}
        >
          <Row>
            <Col span={4}>
              <Typography.Text type="success">
                Link HĐ học viên:
              </Typography.Text>
            </Col>
            <Col flex={1}>
              <Typography.Link>{linkSignByCus}</Typography.Link>
            </Col>
            <Col flex={1}>
              <Button icon={<CopyOutlined />} type="default" onClick={copyLink}>
                Copy Link
              </Button>
            </Col>
          </Row>
        </ModalCustom>
      </Space>
    </Spin>
  );
};

export default ContractList;
